import styles from './TaskCheckbox.module.css';

interface Props {
  done: boolean;
  onToggle: () => void;
  label?: string;
}

export function TaskCheckbox({ done, onToggle, label = 'Toggle task' }: Props) {
  return (
    <button
      type="button"
      className={`${styles.box} ${done ? styles.checked : ''}`}
      onClick={onToggle}
      aria-pressed={done}
      aria-label={label}
    >
      {done ? '✓' : ''}
    </button>
  );
}
